// Iter 104 — Extracted shared helpers previously living at the top of
// SwipeCards.js. Centralising them here keeps the extracted /modals/*
// components self-contained and trims SwipeCards.js.
import { shareStat } from "../../utils/shareStat";
import { hapticSuccess } from "../../utils/haptics";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const f$ = (v, d = 2) => { if (v == null) return "$0.00"; const n = Number(v); if (Math.abs(n) >= 1e6) return "$" + (n / 1e6).toFixed(1) + "M"; if (Math.abs(n) >= 1e3) return "$" + (n / 1e3).toFixed(1) + "K"; return "$" + n.toFixed(d); };
export const fN = (v, d = 2) => v == null ? "—" : Number(v).toFixed(d);
export const fP = (v, d = 1) => v == null ? "—" : Number(v).toFixed(d) + "%";
export const parseOCC = (sym) => { const m = sym?.match(/^([A-Z]+)(\d{2})(\d{2})(\d{2})([CP])(\d{8})$/); if (!m) return null; const [, t, yy, mm, dd, cp, rs] = m; return { ticker: t, strike: parseInt(rs, 10) / 1000, side: cp === "C" ? "Call" : "Put", exp: `${parseInt(mm)}/${parseInt(dd)}` }; };

export const miniChartOpts = { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false }, tooltip: { enabled: false } }, scales: { x: { display: false }, y: { display: false } }, elements: { line: { borderWidth: 1.5 } } };
export const fullChartOpts = (min0) => ({ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false }, tooltip: { mode: "index", intersect: false, backgroundColor: "rgba(13,17,23,0.95)" } }, scales: { x: { ticks: { color: "#636e7b", font: { size: 7 }, maxTicksLimit: 5 }, grid: { display: false } }, y: { ticks: { color: "#636e7b", font: { size: 8 }, callback: v => "$" + v }, grid: { color: "rgba(255,255,255,0.03)" }, ...(min0 ? { min: 0 } : {}) } } });

// iter 101 — regime dot + color helpers for home-grid badges.
export function _regimeColorTile(r) {
  if (r === "BULL" || r === "TRENDING_UP") return "#4ade80";
  if (r === "BEAR") return "#f87171";
  if (r === "VOLATILE") return "#fbbf24";
  if (r === "CHOP") return "#60a5fa";
  return "#a78bfa";
}
export function _regimeDot(r) {
  if (r === "BULL") return "▲";
  if (r === "TRENDING_UP") return "↗";
  if (r === "BEAR") return "▼";
  if (r === "VOLATILE") return "⚡";
  if (r === "CHOP") return "◇";
  return "○";
}

// iter 104 — Crypto coin gradient colors for CryptoExpanded
export const COIN_GRADIENTS = {
  BTC: ["#f7931a", "#ffa734"],
  ETH: ["#627eea", "#8a9ef0"],
  SOL: ["#9945ff", "#14f195"],
  XRP: ["#23292f", "#5c6670"],
  ADA: ["#0033ad", "#3468d1"],
  DOGE: ["#c2a633", "#ebd55a"],
  AVAX: ["#e84142", "#ff6b6c"],
  LINK: ["#2a5ada", "#4e7df0"],
  LTC: ["#345d9d", "#5a85c9"],
  DOT: ["#e6007a", "#ff4fa0"],
  BCH: ["#0ac18e", "#40e0b2"],
  UNI: ["#ff007a", "#ff4ea0"],
  SHIB: ["#e11d48", "#f43f5e"],
  MATIC: ["#8247e5", "#a76df4"],
  NEAR: ["#00c08b", "#2dd4b0"],
  XLM: ["#14b8a6", "#2dd4bf"],
  AAVE: ["#b6509e", "#d470bf"],
  MKR: ["#1aab9b", "#3cc3b3"],
  ATOM: ["#2e3148", "#4a4d66"],
  COMP: ["#00d395", "#2de9ad"],
  FIL: ["#0090ff", "#36b0ff"],
  SAND: ["#00adef", "#36c5ff"],
  MANA: ["#ff2d55", "#ff5c7b"],
  APE: ["#0054fa", "#3479ff"],
  CRV: ["#ef4444", "#ff6b6b"],
};
export const _coinGradient = (sym) => COIN_GRADIENTS[sym] || ["#0891b2", "#0d9488"];

// Helper: show a pop-up "life card" with rich context for any tapped metric.
export function LifeCardPopup({ open, onClose, title, accent, shareable, children }) {
  if (!open) return null;
  const doShare = async (e) => {
    e.stopPropagation();
    try {
      await shareStat({
        title: shareable?.title || title || "Omega stat",
        value: shareable?.value || "",
        subtitle: shareable?.subtitle || "",
        accent: accent || "#38bdf8",
      });
      hapticSuccess();
    } catch {}
  };
  return (
    <div
      data-testid="life-card-overlay"
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 10050,
        background: "rgba(3,7,18,0.72)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="zi-lifecard-pop"
        data-testid="life-card-panel"
        style={{
          width: "100%", maxWidth: 360,
          background: "#0d1117", border: `1px solid ${accent}44`,
          borderRadius: 22, padding: 18,
          boxShadow: `0 20px 60px rgba(0,0,0,0.6), 0 0 0 3px ${accent}22`,
          color: "#e6edf3",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: accent }} />
            <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.3 }}>{title}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {shareable && (
              <button
                data-testid="life-card-share"
                onClick={doShare}
                title="Share stat"
                style={{
                  display: "flex", alignItems: "center", gap: 5,
                  padding: "5px 10px", borderRadius: 12,
                  background: `${accent}22`, border: `1px solid ${accent}55`,
                  color: accent, fontSize: 11, fontWeight: 700, cursor: "pointer",
                }}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                  <polyline points="16 6 12 2 8 6" />
                  <line x1="12" y1="2" x2="12" y2="15" />
                </svg>
                Share
              </button>
            )}
            <button
              data-testid="life-card-close"
              onClick={onClose}
              aria-label="Close"
              style={{
                width: 34, height: 34, borderRadius: 17,
                background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.12)",
                color: "#e6edf3", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center",
                WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
